import type { ReactNode } from "react";

import { header } from "./SignUpHeader.styles";

interface Props {
  children: ReactNode;
  isStorefronts?: boolean;
  hasCompactSpacing?: boolean;
}

const SignUpHeader = ({ children, isStorefronts = false, hasCompactSpacing = false }: Props) => {
  return <div css={header(isStorefronts, hasCompactSpacing)}>{children}</div>;
};

export { SignUpHeader };
